import "./styles.css";
import { useState } from "react";
import { Analytics } from "@vercel/analytics/react"

export default function App() {
  const [isFullScreen, setIsFullScreen] = useState(false);
  return (
    <div
      className="App"
      onDoubleClick={(e) => {
        if (isFullScreen) {
          document.exitFullscreen?.();
          setIsFullScreen(false);
        } else {
          (e.target as HTMLElement).requestFullscreen?.();          
          setIsFullScreen(true);
        }
      }}
    >
      <img src='/concentrate.png' width={40} style={{ userSelect: "none" }} />
      <Analytics />
    </div>
  );
}
